
import { Component, Mixins } from "vue-property-decorator";
import { IMultiLineBehavior } from "../../../../../../documaker/domain/format/objects";
import { IMultiLineBehaviorPropertyEditable, instanceOfIMultiLineBehaviorPropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class MultiLineBehaviorPropertyEditableMixin extends Mixins() {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: IMultiLineBehaviorPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IMultiLineBehaviorPropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isMultiLineBehaviorEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfIMultiLineBehaviorPropertyEditable(s) && s.multiLineBehavior().isEditable(), false);
  }

  get multiLineBehavior(): IMultiLineBehavior {
    return this.readPropertyOrDefault(s => s.multiLineBehavior().getValue(), { isEnable: false });
  }

  set multiLineBehavior(value: IMultiLineBehavior) {
    this.writePropertyWhenValid(s => s.multiLineBehavior().setValue(value));
  }
}
